export function normalizeUsCanadaPhone(input) {
  const raw = String(input || "").trim();
  if (!raw) return null;

  const digits = raw.replace(/\D/g, "");

  if (raw.startsWith("+")) {
    return /^\+1\d{10}$/.test(raw) ? raw : null;
  }

  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;

  return null;
}

export function isValidUsCanadaPhone(input) {
  return normalizeUsCanadaPhone(input) !== null;
}
